// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Insights: wind status and astronomy (sun/moon) charts */

.insight-cards > * {
  border-radius: 20px;
  max-height: 265px;
}

.insight {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.insight__header {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.insight__title {
  margin: 0;
}

.insights__unit {
  font-weight: 600;
  font-size: 0.85rem;
}

.wind-chart {
  width: 100%;
}

.wind-chart__bar {
  width: 2px;
  transition:
    opacity 0.2s ease,
    filter 0.2s ease;
  cursor: help;
}

.wind-chart__bar:hover {
  /* Brighten the bar on hover */
  opacity: 1;
  /* Add a subtle glow effect */
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.8));
}

.wind-chart__trendline {
  fill: none;
  stroke: rgba(0, 255, 255, 0.8);
  stroke-width: 1.5;
  stroke-dasharray: 4 2; /* 4px dash, 2px gap */
  stroke-linecap: round;
  cursor: help;
}

.wind-chart__trendline:hover {
  filter: drop-shadow(0 0 2px rgba(0, 255, 255, 0.5));
}

.wind__stats {
  margin: 0;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}

.wind__stats-item {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.wind__stats-label {
  font-size: 0.9rem;
  font-weight: 300;
}

.wind__stats-value {
  font-variant-numeric: tabular-nums;
}

.insight__header--astronomy {
  justify-content: space-between;
}

.astronomy {
  display: flex;
  flex-direction: column;
}

.astronomy-chart__track {
  fill: none;
  stroke: url(#a);
  stroke-width: 1px;
  stroke-linecap: round;
  stroke-dasharray: 4 8;
}

#astronomy-chart__object {
  transition:
    cx 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    cy 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Sun Mode Styling */
.astronomy-chart__object--sun {
  r: 9px;
  fill: url(#sunGradient); /* References the defs ID */
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.8))
    drop-shadow(0 0 10px rgba(243, 156, 18, 0.6));
}

/* Moon Mode Styling */
.astronomy-chart__object--moon {
  r: 6px;
  fill: #d1d5db; /* A pale, lunar cream */
  filter: drop-shadow(0 0 5px rgba(245, 243, 206, 0.6));
  stroke: #d1d5db;
}

.moon-shroud {
  fill: #111827;
  opacity: 0.8;
  pointer-events: none;
  r: 6px;
}

.astronomy__events {
  display: flex;
  justify-content: space-between;
}

.astronomy__event {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.astronomy__event--rise {
  align-items: start;
  text-align: left;
}

.astronomy__event--set {
  align-items: end;
  text-align: right;
}

.bi {
  /* in-built class of bootstrap SVGs  */
  color: #ffffff;
}

.astronomy__event-label {
  font-weight: 400;
}

.astronomy__event-time {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.astronomy__event-text {
  margin: 0;
}

.astronomy__object {
  max-width: 40%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/insights.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV;;oBAEkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB,EAAE,sBAAsB;EAC7C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE;;wCAEsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,MAAM;EACN,uBAAuB,EAAE,2BAA2B;EACpD;iDAC+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,MAAM;EACN,aAAa,EAAE,wBAAwB;EACvC,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Insights: wind status and astronomy (sun/moon) charts */\n\n.insight-cards > * {\n  border-radius: 20px;\n  max-height: 265px;\n}\n\n.insight {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.insight__header {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.insight__title {\n  margin: 0;\n}\n\n.insights__unit {\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.wind-chart {\n  width: 100%;\n}\n\n.wind-chart__bar {\n  width: 2px;\n  transition:\n    opacity 0.2s ease,\n    filter 0.2s ease;\n  cursor: help;\n}\n\n.wind-chart__bar:hover {\n  /* Brighten the bar on hover */\n  opacity: 1;\n  /* Add a subtle glow effect */\n  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.8));\n}\n\n.wind-chart__trendline {\n  fill: none;\n  stroke: rgba(0, 255, 255, 0.8);\n  stroke-width: 1.5;\n  stroke-dasharray: 4 2; /* 4px dash, 2px gap */\n  stroke-linecap: round;\n  cursor: help;\n}\n\n.wind-chart__trendline:hover {\n  filter: drop-shadow(0 0 2px rgba(0, 255, 255, 0.5));\n}\n\n.wind__stats {\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n}\n\n.wind__stats-item {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n}\n\n.wind__stats-label {\n  font-size: 0.9rem;\n  font-weight: 300;\n}\n\n.wind__stats-value {\n  font-variant-numeric: tabular-nums;\n}\n\n.insight__header--astronomy {\n  justify-content: space-between;\n}\n\n.astronomy {\n  display: flex;\n  flex-direction: column;\n}\n\n.astronomy-chart__track {\n  fill: none;\n  stroke: url(#a);\n  stroke-width: 1px;\n  stroke-linecap: round;\n  stroke-dasharray: 4 8;\n}\n\n#astronomy-chart__object {\n  transition:\n    cx 0.6s cubic-bezier(0.4, 0, 0.2, 1),\n    cy 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Sun Mode Styling */\n.astronomy-chart__object--sun {\n  r: 9px;\n  fill: url(#sunGradient); /* References the defs ID */\n  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.8))\n    drop-shadow(0 0 10px rgba(243, 156, 18, 0.6));\n}\n\n/* Moon Mode Styling */\n.astronomy-chart__object--moon {\n  r: 6px;\n  fill: #d1d5db; /* A pale, lunar cream */\n  filter: drop-shadow(0 0 5px rgba(245, 243, 206, 0.6));\n  stroke: #d1d5db;\n}\n\n.moon-shroud {\n  fill: #111827;\n  opacity: 0.8;\n  pointer-events: none;\n  r: 6px;\n}\n\n.astronomy__events {\n  display: flex;\n  justify-content: space-between;\n}\n\n.astronomy__event {\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n}\n\n.astronomy__event--rise {\n  align-items: start;\n  text-align: left;\n}\n\n.astronomy__event--set {\n  align-items: end;\n  text-align: right;\n}\n\n.bi {\n  /* in-built class of bootstrap SVGs  */\n  color: #ffffff;\n}\n\n.astronomy__event-label {\n  font-weight: 400;\n}\n\n.astronomy__event-time {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.astronomy__event-text {\n  margin: 0;\n}\n\n.astronomy__object {\n  max-width: 40%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
